module.exports = __webpack_public_path__ + "img/payment_mb_03.cd0e2db4.png";